import * as React from "react";
import { memo } from "react";

const SvgMouse = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 13 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.111 20C2.75 20 0 17.25 0 13.889V6.11C0 2.75 2.75 0 6.111 0c3.361 0 6.111 2.75 6.111 6.111v7.778c0 3.36-2.75 6.111-6.11 6.111Zm0-18.889c-2.75 0-5 2.25-5 5v7.778c0 2.75 2.25 5 5 5s5-2.25 5-5V6.11c0-2.75-2.25-5-5-5Z"
      fill="#000"
    />
    <path
      d="M6.111 6.944a.557.557 0 0 1-.555-.555V4.167c0-.306.25-.556.555-.556.306 0 .556.25.556.556v2.222c0 .305-.25.555-.556.555Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgMouse);
export default Memo;
